import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { AppStoreModule, TenantDetailsStoreModule } from '@/store';
import { CloudOrganizationSummary } from '@/common/models';
import IAdminService from '@/services/http/interfaces/IAdminService';

export interface ICloudOrganizationsState {
  cloudOrganizations: CloudOrganizationSummary[];
}

@Module({
  name: 'cloudOrganizations',
  namespaced: true,
})
export default class CloudOrganizationsStore extends VuexModule implements ICloudOrganizationsState {

  // State
  cloudOrganizations: CloudOrganizationSummary[] = [];

  // Getters
  get currentCloudOrganization(): CloudOrganizationSummary | undefined | null {
    return this.cloudOrganizations ? this.cloudOrganizations!.find((o) => o.tenantId === TenantDetailsStoreModule.tenantDetails!.tenantId) : undefined;
  }

  // Mutations
  @Mutation
  SET_CLOUDORGANIZATION_SUMMARY(cloudOrganizations: CloudOrganizationSummary[]) {
    this.cloudOrganizations = cloudOrganizations;
  }

  // Actions
  @Action
  async getCloudOrganizations(adminService: IAdminService) {

    AppStoreModule.SET_ISLOADING(true);

    await adminService.getCloudOrganizations()
      .then((cloudOrganizations: CloudOrganizationSummary[]) => {
        this.SET_CLOUDORGANIZATION_SUMMARY(cloudOrganizations);
      })
      .catch(() => {
        AppStoreModule.SAVE_HTTP_ERROR('Unable to load cloud organizations');
      })
      .finally(() => {
        AppStoreModule.SET_ISLOADING(false);
      });
  }
}
